import NewGroupContainer from './containers/NewGroupContainer'

export default NewGroupContainer
